import http from './http';

export default {
  AddTaskAutomation: {
    all() {
      return http().get(`/v1/add_task_automations`);
    },
    get(id) {
      return http().get(`/v1/add_task_automations/${id}`);
    },
    create(data) {
      return http().post(`/v1/add_task_automations`, data);
    },
    update(data) {
      return http().put(`/v1/add_task_automations/${data.id}`, data);
    },
    delete(id) {
      return http().delete(`/v1/add_task_automations/${id}`);
    },
  },
  NotifyUsersAutomation: {
    all() {
      return http().get(`/v1/notify_users_automations`);
    },
    get(id) {
      return http().get(`/v1/notify_users_automations/${id}`);
    },
    create(data) {
      return http().post(`/v1/notify_users_automations`, data);
    },
    update(data) {
      return http().put(`/v1/notify_users_automations/${data.id}`, data);
    },
    delete(id) {
      return http().delete(`/v1/notify_users_automations/${id}`);
    },
  },
  ManageUsersAutomation: {
    all() {
      return http().get(`/v1/manage_users_automations`);
    },
    get(id) {
      return http().get(`/v1/manage_users_automations/${id}`);
    },
    create(data) {
      return http().post(`/v1/manage_users_automations`, data);
    },
    update(data) {
      return http().put(`/v1/manage_users_automations/${data.id}`, data);
    },
    delete(id) {
      return http().delete(`/v1/manage_users_automations/${id}`);
    },
  },
  UpdateRecordTemperatureAutomation: {
    all() {
      return http().get(`/v1/update_record_temperature_automations`);
    },
    get(id) {
      return http().get(`/v1/update_record_temperature_automations/${id}`);
    },
    create(data) {
      return http().post(`/v1/update_record_temperature_automations`, data);
    },
    update(data) {
      return http().put(`/v1/update_record_temperature_automations/${data.id}`, data);
    },
    delete(id) {
      return http().delete(`/v1/update_record_temperature_automations/${id}`);
    },
  },
  SendWebhookAutomation: {
    all() {
      return http().get(`/v1/send_webhook_automations`);
    },
    get(id) {
      return http().get(`/v1/send_webhook_automations/${id}`);
    },
    create(data) {
      return http().post(`/v1/send_webhook_automations`, data);
    },
    update(data) {
      return http().put(`/v1/send_webhook_automations/${data.id}`, data);
    },
    delete(id) {
      return http().delete(`/v1/send_webhook_automations/${id}`);
    },
  },
  EmailAutomation: {
    all() {
      return http().get(`/v1/email_automations`);
    },
    get(id) {
      return http().get(`/v1/email_automations/${id}`);
    },
    create(data) {
      return http().post(`/v1/email_automations`, data);
    },
    update(data) {
      return http().put(`/v1/email_automations/${data.id}`, data);
    },
    delete(id) {
      return http().delete(`/v1/email_automations/${id}`);
    },
  },
  TextAutomation: {
    all() {
      return http().get(`/v1/text_automations`);
    },
    get(id) {
      return http().get(`/v1/text_automations/${id}`);
    },
    create(data) {
      return http().post(`/v1/text_automations`, data);
    },
    update(data) {
      return http().put(`/v1/text_automations/${data.id}`, data);
    },
    delete(id) {
      return http().delete(`/v1/text_automations/${id}`);
    },
  },
  AddContactTagAutomation: {
    all() {
      return http().get(`/v1/add_contact_tag_automations`);
    },
    get(id) {
      return http().get(`/v1/add_contact_tag_automations/${id}`);
    },
    create(data) {
      return http().post(`/v1/add_contact_tag_automations`, data);
    },
    update(data) {
      return http().put(`/v1/add_contact_tag_automations/${data.id}`, data);
    },
    delete(id) {
      return http().delete(`/v1/add_contact_tag_automations/${id}`);
    },
  },
  AddToFollowUpSequenceAutomation: {
    all() {
      return http().get(`/v1/add_to_follow_up_sequence_automations`);
    },
    get(id) {
      return http().get(`/v1/add_to_follow_up_sequence_automations/${id}`);
    },
    create(data) {
      return http().post(`/v1/add_to_follow_up_sequence_automations`, data);
    },
    update(data) {
      return http().put(`/v1/add_to_follow_up_sequence_automations/${data.id}`, data);
    },
    delete(id) {
      return http().delete(`/v1/add_to_follow_up_sequence_automations/${id}`);
    },
  },
}
